import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { VIEWS } from '../constants';

/**
 * Clears app state and navigates home when the active workspace changes.
 */
export function useWorkspaceReset({
  workspaceId,
  flushAllPendingSaves,
  setSprints,
  clearActiveView,
  setSelectedSprintId,
  setSelectedTemplateId,
  setCurrentView,
  setPreferredDetailView,
  setPendingMissionFocus,
  setIsLoadingItem,
  resetStartup,
}) {
  const navigate = useNavigate();
  const prevWorkspaceNavRef = useRef();

  useEffect(() => {
    const prior = prevWorkspaceNavRef.current;
    if (prior !== undefined && prior !== workspaceId) {
      // Saves are pinned to their origin workspace, so flushing after the
      // switch still writes them to the right partition (no bleed, no loss).
      flushAllPendingSaves();
      setSprints([]);
      clearActiveView();
      setSelectedSprintId(null);
      setSelectedTemplateId(null);
      setCurrentView(VIEWS.EMPTY);
      setPreferredDetailView(null);
      setPendingMissionFocus(null);
      setIsLoadingItem(false);
      resetStartup();
      navigate('/', { replace: true });
    }
    prevWorkspaceNavRef.current = workspaceId;
  }, [
    workspaceId,
    navigate,
    flushAllPendingSaves,
    setSprints,
    clearActiveView,
    setSelectedSprintId,
    setSelectedTemplateId,
    setCurrentView,
    setPreferredDetailView,
    setPendingMissionFocus,
    setIsLoadingItem,
    resetStartup,
  ]);
}
